import React, { useState } from 'react';
import { Project } from '../../data/projectsData';
import Grainient from '../Grainient/Grainient';
import './ProjectCard.css';

interface ProjectCardProps {
  project: Project;
  isDark: boolean;
  onClick: (route: string | null | undefined) => void;
  deferredReveal?: boolean;
  cardRef?: (el: HTMLDivElement | null) => void;
  videoRef?: (el: HTMLVideoElement | null) => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  isDark,
  onClick,
  deferredReveal = false,
  cardRef,
  videoRef,
}) => {
  const [hovered, setHovered] = useState(false);
  const accentStyle = { '--proj-accent': project.color || 'var(--text-color)' } as React.CSSProperties;

  return (
    <div className={`proj-card ${project.cardClass || ''}`} ref={cardRef} style={accentStyle}>
      <div
        className={`proj-card-bg ${project.route ? 'clickable' : ''}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => onClick(project.route)}
      >
        <Grainient
          color1={isDark ? '#1a1a1a' : '#ffffff'}
          color2={isDark ? '#1a1a1a' : '#ffffff'}
          color3={project.color || '#FF4141'}
          grainAmount={0.06}
          warpStrength={0.8}
          timeSpeed={0.15}
        />
        <div className="proj-card-content">
          <div className="proj-card-text">
            {project.logos && project.logos.length > 0 ? (
              <div className="proj-card-logo">
                {project.logos.map((logoUrl, logoIndex) => (
                  <img key={logoIndex} src={logoUrl} alt={`${project.company || 'Project'} logo ${logoIndex + 1}`} />
                ))}
              </div>
            ) : project.logo && (
              <div className="proj-card-logo">
                <img src={project.logo} alt={`${project.company} logo`} />
              </div>
            )}
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            {project.tags && (
              <div className="proj-card-tags">
                {project.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className={`proj-card-tag ${tag === 'National Designathon Winner' ? 'golden' : ''}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div className="proj-card-media">
            {project.video ? (
              <video
                ref={videoRef}
                className={`proj-card-video ${deferredReveal ? 'is-deferred' : ''}`}
                autoPlay={!deferredReveal}
                loop
                muted
                playsInline
              >
                <source src={project.video} type="video/mp4" />
              </video>
            ) : (
              <div className="proj-card-video-placeholder">
                {project.mediaOverlayImg && (
                  <img src={project.mediaOverlayImg} alt="" className="proj-card-media-overlay-img" />
                )}
              </div>
            )}
          </div>
        </div>
        {hovered && project.route && (
          <div className="proj-card-view-indicator">
            <span>View Project</span>
            <span className="proj-card-arrow">→</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
